export default function guest( { next, store }){
    let user = store.state.user;
    if (user && user.status == 'ACTIVE') {
        return next({
            name: 'dashboard'
        })
    }
//    else if (user && user.status == 'UN_VERIFIED') {
//        return next({
//            name: 'dashboard'
//        })
//    }

    return next()
}
